import React, { useState } from 'react';
import { XIcon, SearchIcon, CheckIcon, LayersIcon } from 'lucide-react';
import { SelectedGLDimensions } from '../types/glCoding';
interface BulkGLCodingModalProps {
  lineItemCount: number;
  vendor: string;
  onApply: (glCode: string, dimensions: SelectedGLDimensions) => void;
  onClose: () => void;
}
const MOCK_GL_CODES = [{
  code: '6100-1000',
  description: 'Office Supplies - General'
}, {
  code: '6100-2000',
  description: 'Office Supplies - Stationery'
}, {
  code: '6200-1000',
  description: 'Professional Services - Consulting'
}, {
  code: '6200-2000',
  description: 'Professional Services - Legal'
}, {
  code: '6300-1000',
  description: 'IT Equipment - Hardware'
}, {
  code: '6300-2000',
  description: 'IT Equipment - Software'
}];
export function BulkGLCodingModal({
  lineItemCount,
  vendor,
  onApply,
  onClose
}: BulkGLCodingModalProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCode, setSelectedCode] = useState('');
  const filteredCodes = MOCK_GL_CODES.filter(gl => gl.code.toLowerCase().includes(searchQuery.toLowerCase()) || gl.description.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleApply = () => {
    if (selectedCode) {
      onApply(selectedCode, {});
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-4068">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[80vh] overflow-hidden flex flex-col" data-id="element-4069">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-4070">
          <div className="flex items-center gap-3 mb-2" data-id="element-4071">
            <div className="p-2 bg-indigo-100 rounded-lg" data-id="element-4072">
              <LayersIcon className="w-5 h-5 text-indigo-600" data-id="element-4073" />
            </div>
            <div data-id="element-4074">
              <h2 className="text-lg font-semibold text-gray-900" data-id="element-4075">
                Apply GL Code to All Lines
              </h2>
              <p className="text-sm text-gray-600" data-id="element-4076">
                This will apply the selected GL code to all {lineItemCount} line
                items
              </p>
            </div>
          </div>
          <div className="mt-3 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg" data-id="element-4077">
            <p className="text-sm text-amber-800" data-id="element-4078">
              <strong data-id="element-4079">Vendor:</strong> {vendor}
            </p>
          </div>
        </div>

        {/* Search */}
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-4080">
          <div className="relative" data-id="element-4081">
            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-4082" />
            <input type="text" placeholder="Search GL codes..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent" data-id="element-4083" />
          </div>
        </div>

        {/* GL Code List */}
        <div className="flex-1 overflow-y-auto p-4" data-id="element-4084">
          <div className="space-y-2" data-id="element-4085">
            {filteredCodes.map(gl => <button key={gl.code} onClick={() => setSelectedCode(gl.code)} className={`w-full text-left px-4 py-3 rounded-lg border transition-colors ${selectedCode === gl.code ? 'border-indigo-500 bg-indigo-50' : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-4086">
                <div className="flex items-center justify-between" data-id="element-4087">
                  <div data-id="element-4088">
                    <code className="text-sm font-mono font-medium text-gray-900" data-id="element-4089">
                      {gl.code}
                    </code>
                    <p className="text-sm text-gray-600 mt-0.5" data-id="element-4090">
                      {gl.description}
                    </p>
                  </div>
                  {selectedCode === gl.code && <CheckIcon className="w-5 h-5 text-indigo-600" data-id="element-4091" />}
                </div>
              </button>)}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-end gap-3" data-id="element-4092">
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-4093">
            Cancel
          </button>
          <button onClick={handleApply} disabled={!selectedCode} className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-4094">
            Apply to All {lineItemCount} Lines
          </button>
        </div>
      </div>
    </div>;
}